import { render, staticRenderFns } from "./StudentPastAppointmentsList.vue?vue&type=template&id=6258a31a"
import script from "./StudentPastAppointmentsList.vue?vue&type=script&lang=js"
export * from "./StudentPastAppointmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports